import { render, staticRenderFns } from "./reallocateSample.vue?vue&type=template&id=7e00a340&"
import script from "./reallocateSample.vue?vue&type=script&lang=js&"
export * from "./reallocateSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports